export function emptyFunc(): void { }

export function replaceUnicode(sourceStr: string): string {
    // UniCode编码表及部分不可见字符过滤方案
    // https://www.cnblogs.com/fan-yuan/p/8176886.html
    const reg = '['
        + '\u0000-\u001F' // ：C0控制符及基本拉丁文 (C0 Control and Basic Latin)
        + '\u007F-\u00A0' // ：特殊 (Specials);
        + ']';
    const regExp = new RegExp(reg);
    // let matcher = pattern.matcher(sourceStr);
    return sourceStr.replace(regExp, '');
}
